import { render, staticRenderFns } from "./sendMessageModal.vue?vue&type=template&id=4b45a6bc&"
import script from "./sendMessageModal.vue?vue&type=script&lang=js&"
export * from "./sendMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports